export const routeWithSidebarTheme = {
   light: {
      routeComponentContainer: {
         backgroundColor: 'bg-base-white'
      }
   },
   dark: {}
}
